export const getLocalStorage = key => {
  try {
    const item = window.localStorage.getItem(key)

    return JSON.parse(item)
  } catch (error) {
    return undefined
  }
}

export const setLocalStorage = (key, value) => {
  try {
    const item = JSON.stringify(value)

    window.localStorage.setItem(key, item)
  } catch (error) {
    return undefined
  }
}
